import { useQuery } from "@tanstack/react-query";
import { fetchSetupFees } from "../actions/setup-fees.action";

export const SETUP_FEES_QUERY_KEY = ["setup-fees"];

export function useSetupFeesQuery() {
  return useQuery({
    queryKey: SETUP_FEES_QUERY_KEY,
    queryFn: fetchSetupFees,
    refetchOnWindowFocus: false,
  });
}
